import { m8API } from 'services/production/m8';
import { DeleteTariffService } from 'types/services';

export const deleteTariff: DeleteTariffService = async (params) => {
  await m8API.admin.deletePrice({
    idPrice: params.tariffId,
  });
};
